import * as React from 'react'
import {MdKeyboardArrowLeft as ChevronLeft} from 'react-icons/md'

import {isFindHotelBrand} from '@daedalus/core/src/customerSupport/business'
import {defaultBrand} from '@daedalus/core/src/brand/config'
import WithAuthEnabled from '@daedalus/core/src/auth/components/WithAuthEnabled'
import Grid from '../../../designSystem/helpers/Grid'
import BrandLogo from '../../../designSystem/BrandLogo'
import urls from '@daedalus/core/src/utils/url'
import PageWidthContainer from '../../../designSystem/helpers/PageWidthContainer'
import PreferenceSelectorDesktop from '../../user/PreferenceSelector/Desktop'

import {
  HeaderElement,
  BackButtonElement,
  LogoWrapper,
  LogoElement,
  LogoLinkElement,
  LogoAnchorElement,
  HeaderControlsWrapper,
  UserControlWrapper
} from './styles'

import {CurrencyType} from '@daedalus/core/src/localization/types/CurrencyType'
import {LanguageType} from '@daedalus/core/src/localization/types/LanguageType'
import {BrandType} from '@daedalus/core/src/brand/types'
interface PropsType {
  /** A user that should represent a user widget */
  UserWidget: React.ElementType
  /** A list of available languages */
  availableLanguages: LanguageType[]
  /** Brand configuration. It can be FindHotel or Etrip */
  brand?: BrandType
  /** A list of available currencies */
  currenciesList: CurrencyType[]
  /** The current selected currency */
  currentCurrency: string
  /** The current selected language */
  currentLanguage: string
  /** Whether to disable the click action in the logo */
  disableLogoClick?: boolean
  /** Make it visible or not the preferences bar */
  disablePreferences?: boolean
  /** An action fired when the user clicks on the side action button */
  onActionButtonClick?: () => void
  /** An action fired when the user clicks in a different currency */
  onChangeCurrency: (arg0: string) => void
  /** An action fired when the user clicks in a different language */
  onChangeLanguage: (arg0: string) => void
  /** Callback fired on currency button click */
  onClickCurrency?: () => void
  /** Callback fired on language button click */
  onClickLanguage?: () => void
  /** List of popular currencies */
  popularCurrenciesList?: CurrencyType[]
  /** Make it visible or not the back button  */
  showBackButton?: boolean
  /** Which url should the logo send the user when clicked upon */
  logoUrl?: string
  /** Should it render the language selector */
  hasLanguageSelector?: boolean
  /** Should it render the currency selector */
  hasCurrencySelector?: boolean
}

interface LogoType {
  disableLogoClick?: boolean
  brand: BrandType
  logoUrl?: string
}

interface BackButtonType {
  showBackButton?: boolean
  handleBackClick: PropsType['onActionButtonClick']
}

const Logo = ({disableLogoClick, brand, logoUrl}: LogoType) => {
  if (disableLogoClick) {
    return (
      <LogoElement brand={brand.code}>
        <BrandLogo brand={brand} />
      </LogoElement>
    )
  }

  if (logoUrl) {
    return (
      <LogoAnchorElement brand={brand.code} href={logoUrl}>
        <BrandLogo brand={brand} />
      </LogoAnchorElement>
    )
  }

  return (
    <LogoLinkElement brand={brand.code} to={urls.root}>
      <BrandLogo brand={brand} />
    </LogoLinkElement>
  )
}

const BackButton = ({showBackButton, handleBackClick}: BackButtonType) => {
  return showBackButton ? (
    <BackButtonElement onClick={handleBackClick}>
      <ChevronLeft size={24} />
    </BackButtonElement>
  ) : null
}

const Header = ({
  availableLanguages,
  brand = defaultBrand,
  currentLanguage,
  disablePreferences,
  onChangeLanguage,
  currentCurrency,
  currenciesList,
  popularCurrenciesList,
  onChangeCurrency,
  UserWidget,
  showBackButton,
  disableLogoClick,
  logoUrl,
  onActionButtonClick,
  hasLanguageSelector,
  hasCurrencySelector,
  onClickCurrency,
  onClickLanguage
}: PropsType) => {
  const handleBackClick = (): void => {
    onActionButtonClick?.()
  }

  return (
    <HeaderElement>
      <PageWidthContainer paddingDesktopXsSize="s500">
        <Grid container justify="space-between" spacing="s000">
          <Grid container desktopXs={6}>
            {showBackButton && (
              <Grid desktopXs={1}>
                <BackButton
                  showBackButton={showBackButton}
                  handleBackClick={handleBackClick}
                />
              </Grid>
            )}
            <Grid desktopXs={4}>
              <LogoWrapper>
                <Logo
                  disableLogoClick={disableLogoClick}
                  brand={brand}
                  logoUrl={logoUrl}
                />
              </LogoWrapper>
            </Grid>
          </Grid>
          {!disablePreferences && (
            <Grid desktopXs={6}>
              <HeaderControlsWrapper>
                <WithAuthEnabled>
                  {isFindHotelBrand(brand.code) && (
                    <UserControlWrapper>
                      {UserWidget && <UserWidget />}
                    </UserControlWrapper>
                  )}
                </WithAuthEnabled>

                <PreferenceSelectorDesktop
                  availableLanguages={availableLanguages}
                  currentLanguage={currentLanguage}
                  currentCurrency={currentCurrency}
                  currenciesList={currenciesList}
                  popularCurrenciesList={popularCurrenciesList}
                  hasLanguageSelector={hasLanguageSelector}
                  hasCurrencySelector={hasCurrencySelector}
                  onChangeCurrency={onChangeCurrency}
                  onChangeLanguage={onChangeLanguage}
                  onClickCurrency={onClickCurrency}
                  onClickLanguage={onClickLanguage}
                />
              </HeaderControlsWrapper>
            </Grid>
          )}
        </Grid>
      </PageWidthContainer>
    </HeaderElement>
  )
}

export default Header
